import { createApi } from "@reduxjs/toolkit/query/react"
import { authQuery } from "./authQuery"
import { ValidationErrorResponse } from "@custom-types/common"

export type PostValidationFilePayload = {
  data: File
  graph_id: string
}

type PostValidationFileResponse =
  | SuccessfullPostValidationFileResponse
  | ErrorPostValidationFileResponse

type SuccessfullPostValidationFileResponse = {
  validation_hash: string
  path: string
  message: string
}

type ErrorPostValidationFileResponse = {
  message: string
}

export const validationApi = createApi({
  reducerPath: "validationApi",
  baseQuery: authQuery,
  tagTypes: ["validation"],
  endpoints: (builder) => ({
    getGraphValidationFile: builder.query<string, string>({
      query: (key) => ({
        url: `/editor/validation?graph_id=${encodeURIComponent(key)}`,
      }),
      providesTags: ["validation"],
    }),
    postValidationFile: builder.mutation<PostValidationFileResponse, PostValidationFilePayload>({
      query: (payload) => {
        const formData = new FormData()
        formData.set("data", payload.data)
        formData.set("graph_id", payload.graph_id)

        return {
          url: "/document/upload-validation-document",
          method: "POST",
          body: formData,
        }
      },
      invalidatesTags: ["validation"],
    }),
    deleteValidationFile: builder.mutation<ValidationErrorResponse | string, string>({
      query: (payload) => {
        return {
          url: `/editor/validation?graph_id=${encodeURIComponent(payload)}`,
          method: "DELETE",
        }
      },
      invalidatesTags: ["validation"],
    }),
  }),
})

export const {
  useGetGraphValidationFileQuery,
  useLazyGetGraphValidationFileQuery,
  usePostValidationFileMutation,
  useDeleteValidationFileMutation,
} = validationApi
